import type { QueryKey } from '@tanstack/react-query';
import type {
  CashListParams,
  GetCashListTransactionGroupParams,
  GetCashListTransactionsParams,
} from './api';

export const CASH_TRANSACTION_GROUP_LIST_PHOENIX_KEY = (
  params?: GetCashListTransactionGroupParams['params']
): QueryKey => {
  const base = 'cash-transaction-group-list-phoenix';
  if (params) {
    return [base, params];
  }
  return [base];
};

export const CASH_TRANSACTION_GROUP_FROM_PLIANT_PHOENIX_KEY = (): QueryKey => {
  const base = 'cash-transaction-group-from-pliant';
  return [base];
};

export const TRANSFER_KEY = (): QueryKey => {
  const base = 'cash-list-transfer';
  return [base];
};

export const CASH_LISTS_PHOENIX_KEY = (
  params?: CashListParams['params']
): QueryKey => {
  const base = 'cash-lists';
  if (params) {
    return [base, params];
  }
  return [base];
};

export const CASH_LIST_CONFIGURATION_PHOENIX_KEY = (
  nursingHomeId: string
): QueryKey => {
  const base = 'cash-list-configuration';
  return [base, nursingHomeId];
};

export const CASH_LIST_TRANSACTIONS_PHOENIX_KEY = (
  params?: GetCashListTransactionsParams['params']
): QueryKey => {
  const base = 'cash-list-transactions-phoenix';
  if (!params) {
    return [base];
  }
  return [base, params];
};

export const CURRENCIES_PHOENIX_KEY = (): QueryKey => {
  const base = 'currencies';
  return [base];
};

export const CASH_TRANSACTION_GROUP_PHOENIX_KEY = (
  groupId: string | undefined
): QueryKey => {
  const base = 'cash-transaction-group-phoenix';
  return [base, groupId || ''];
};
